import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="container-app px-6 py-20 grid place-items-center">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border border-gray-100 p-10">
        <XCircle size={64} className="mx-auto text-[#E48967]"/>
        <h1 data-testid="payment-cancel-title" className="mt-4 font-heading text-3xl font-bold text-[#1A1A1A]">Payment cancelled</h1>
        <p className="text-[#595959] mt-2">No worries — your cart is still saved.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/cart" data-testid="back-to-cart-btn">
            <Button className="rounded-full bg-[#638971] hover:bg-[#4F705B] text-white">Back to cart</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
